export enum AudioResponse {
  'lights' = 'lights',
  'error' = 'error',
  'front-door' = 'front-door',
}

enum Response {
  'action-movies' = 'action-movies',
  'children-shows' = 'children-shows',
}

export const VoiceCommandResponse = { ...AudioResponse, ...Response };

export type VoiceCommandResponseKey = keyof typeof VoiceCommandResponse;

export type AudioResponseKey = keyof typeof AudioResponse;
